import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode;
}

const AddControl = React.forwardRef<HTMLDivElement, Props>(({ className, label, ...props }, ref) => {
  return (
    <div className={classNames('text-primary clickable', className)} {...props} ref={ref}>
      <FontAwesomeIcon className="me-1" icon={faCirclePlus} />
      {label}
    </div>
  );
});

AddControl.displayName = 'AddControl';
export default AddControl;
